import { useState } from "react";
import { cadastrarIndicacaoParceiro } from "../../../services/cadastrarIndicacaoParceiroService";
import { numberPadrao } from "../../../uteis/formatPhoneNumber";
import { cadastrarLead } from "../../../services/cadastrarLeadService";
import { buscarLeadsByCelService } from "../../../services/buscarLeadsByCelService";
import { buscarUsuarioProprietarioByCel } from "../../../services/buscarUsuarioProprietarioByCelService";

export const useIndicacaoParceiro = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const obterOuCadastrarLead = async (data: any) => {
    const celularFormatado = numberPadrao(data.celular);

    const lead = await buscarLeadsByCelService(celularFormatado);

    if (lead) {
      return lead.id;
    }

    const novoLead = await cadastrarLead({
      nome: data.nome,
      celular: celularFormatado,
      active: 1,
      status: "DIVULGAR",
      tipo: "INDICACAO_JURIDICO",
    });

    return novoLead.id;
  };

  const cadastrar = async (data: Partial<any>): Promise<boolean> => {
    setIsLoading(true);

    try {
      const idLead = await obterOuCadastrarLead(data);

      const dataIndicacao = {
        idParceiro: 1,
        idLeads: idLead,
        active: 1,
      };

      const response = await cadastrarIndicacaoParceiro(dataIndicacao);

      if (response) {
        //Salva local
        localStorage.setItem("indicacaoJuridica", JSON.stringify(data));

        setSuccess("Informação cadastrada com sucesso.");

        return true;
      } else {
        setError("Erro ao cadastrar, por favor tente novamente.");
        return false;
      }
    } catch (error: any) {
      console.error(error);
      setError("Erro inesperado ao cadastrar.");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { cadastrar, error, success, resetSuccess, resetError, isLoading };
};
